import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Selectors } from "@/store/masterSearch/selectors";
import { Actions } from "@/store/masterSearch/slice";
import Loadable from "./loadable";
import PT from "prop-types";
import Modal from "_c/Modals";
import { useSearchableSpecsQuery } from '@/hooks/queries/useSearchableSpecsQuery';

const SearchFiltersModal = (props) => {
  const specs = useSearchableSpecsQuery().data ?? [];
  const isOpen = useSelector(Selectors.isFiltersOpen);
  const dispatch = useDispatch();
  const onClose = () => dispatch(Actions.toggleFilters());
  return (
    <Modal mobileBp={600} onClose={onClose} isOpen={isOpen}>
      <Loadable specs={specs} onClose={onClose} {...props} />
    </Modal>
  );
};
SearchFiltersModal.propTypes = {
  query: PT.object.isRequired,
  params: PT.object.isRequired,
  t: PT.func.isRequired,
};

export default SearchFiltersModal;
